var _path, _rect, _line, _line2, _line3, _polyline, _polyline2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorSupermarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.465,39.197H12.535c-2.067,0-3.875-1.389-4.408-3.386l-3.588-13.451h32.922l-3.588,13.451c-.533,1.997-2.341,3.386-4.408,3.386Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.799,
    y: 16.931,
    width: 36.402,
    height: 5.429,
    rx: 2.715,
    ry: 2.715
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21.038,
    y1: 25.85,
    x2: 21.038,
    y2: 34.806
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 26.937,
    y1: 25.85,
    x2: 26.937,
    y2: 34.806
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15.139,
    y1: 25.85,
    x2: 15.139,
    y2: 34.806
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "8.317 16.931 17.935 2.803 17.935 2.803"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "33.659 16.931 24.041 2.803 24.041 2.803"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorSupermarket);
export default __webpack_public_path__ + "static/media/indoor-supermarket.60302c1533beb4b2468f2fb3b07adf9b.svg";
export { ForwardRef as ReactComponent };